
import envs from './env';
import { mobileCheck, tabletCheck, extendTag } from './helper';

var deviceTargets = [];
var tempArr = [];
var bitset = `${getDevice()}${envs.bitset}`;

function checkTarget(tag, isChild) {
  if (tag.target && tag.target.devices !== undefined) {
    let target = pad(tag.target.devices.toString(2), 8);
    let result = compare(bitset, target);
    if (result) {
      return true
    } else return false;
  } else {
    if (isChild) return false;
    else return true;
  }
}

function iterateChildren(tags, children, parent) {
  children.some(item => {
    if (checkTarget(item) && item.show_tag && item.tag_enabled) {
      // let tagSource = findTag(tags, item.src_tag_id);
      // item = extendTag(tagSource ? tagSource : parent, item);
      item = extendTag(tags, item);
      tempArr.push(item);
      return true;
    }
  });
}

function iterateTags(tags) {
  try {
    var decisionTags = tags.filter(item => item.settings.category === '15');
    var decisions = decisionTags.map(item => {
      let meta = item.details.engagements && item.details.engagements[0] && item.details.engagements[0].meta;
      // added the DP tag target to its linked tags obj---
      meta = meta.map(linkedTag => ({ ...linkedTag, dpTarget: item.target }));
      return meta;
    });
    // created mapping between the linked tag [key] and its dp tag target [value]---
    var linkedTagMap = {};
    decisions && [].concat(...decisions).forEach(item => {
      linkedTagMap[item.tag]= item.dpTarget;
    });
  } catch(e) {}

  tags.map((item, index) => {
    if (decisionTags.length && !!linkedTagMap[item.id]) {
      // overwriting the linked tag target by its DP tag target---
      item.target = linkedTagMap[item.id];
      if(checkTarget(item)){
        tempArr.push(item);
      }
    } else if (checkTarget(item) && item.show_tag && item.tag_enabled) {
      tempArr.push(item);
    } else {
      if (item.child_tags) {
        iterateChildren(tags, item.child_tags, item);
      }
    }
  });
}

function getDevice() {
  if (mobileCheck()) return '010';
  else if (tabletCheck()) return '001';
  else return '100';
}

function pad(s, size) {
  while (s.length < size) s = '0' + s;
  return s;
}

function compare(bitset, target) {
  var result = true;

  if (target === '00000000') {
    return true;
  }

  for (var i = 0; i < bitset.length; i++) {
    if (bitset[i] === '1') {
      if (bitset[i] !== target[i]) {
        result = false;
        break;
      }
    }
  }

  return result;
}

export function resolveTargets(json) {
  var tags = json.tags.slice();
  iterateTags(tags);

  return tempArr;
}



// WEBPACK FOOTER //
// ./components/targets.js